// removed by extract-text-webpack-plugin
module.exports = {"ba-modal":"magazines_2l8LX","ba-modal-card":"magazines_15hlk","ba-relative":"magazines_1jdac","ba-img":"magazines_AXfnH","ba-absolute":"magazines_3dB4y","ba-none":"magazines_2T1gP"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dashboard/components/MagazineModal/styles.scss
// module id = 1030
// module chunks = 1